import pConfig from 'pConfig';

let Provider = 'ExerciseCheck';

if (location.pathname.match(/alibaba/)) {
  Provider = 'AlibabaExerciseCheck';
}

const channel = pConfig.config.channel;

export default {
  fetchPlans(id, date) {
    return this.http(
      Provider,
      'get',
      `${channel}/sports/activities/${id}/sports_plan?date=${date}`
    );
  },

  updateRecord(params) {
    return this.http(
      Provider,
      'post',
      `${channel}/sports/activities/record`,
      params
    );
  },

  getUploadToken(key) {
    return this.http(Provider, 'get', '/api/v1/upload_token', {
      key: key
    });
  },

  getReport(id) {
    return this.http(Provider, 'get', `${channel}/sports/reports`, {
      id: id
    });
  },

  getRecords(id) {
    return this.http(
      Provider,
      'get',
      `${channel}/sports/activities/${id}/sports_cal`
    );
  },

  gerStatus(id) {
    return this.http(
      Provider,
      'get',
      `${channel}/sports/activities/${id}/sports_status`
    );
  },

  getUser() {
    return this.http(Provider, 'get', `${channel}/sports/users/user_info`).then(
      res => {
        return res;
      }
    );
  },

  updateUserInfo(params) {
    return this.http(
      Provider,
      'post',
      `${channel}/sports/users/update_info`,
      params
    );
  }
};
